var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTaxReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "lab_profile"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "lab_profile_2",
    d: "M9 12H15C15.2833 12 15.5208 11.9042 15.7125 11.7125C15.9042 11.5208 16 11.2833 16 11C16 10.7167 15.9042 10.4792 15.7125 10.2875C15.5208 10.0958 15.2833 10 15 10H9C8.71667 10 8.47917 10.0958 8.2875 10.2875C8.09583 10.4792 8 10.7167 8 11C8 11.2833 8.09583 11.5208 8.2875 11.7125C8.47917 11.9042 8.71667 12 9 12ZM9 8H15C15.2833 8 15.5208 7.90417 15.7125 7.7125C15.9042 7.52083 16 7.28333 16 7C16 6.71667 15.9042 6.47917 15.7125 6.2875C15.5208 6.09583 15.2833 6 15 6H9C8.71667 6 8.47917 6.09583 8.2875 6.2875C8.09583 6.47917 8 6.71667 8 7C8 7.28333 8.09583 7.52083 8.2875 7.7125C8.47917 7.90417 8.71667 8 9 8ZM19.95 20.475L15.9 15.2C15.6167 14.8167 15.2667 14.5208 14.85 14.3125C14.4333 14.1042 13.9833 14 13.5 14H4V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V20C20 20.0833 19.9958 20.1625 19.9875 20.2375C19.9792 20.3125 19.9667 20.3917 19.95 20.475ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V16H13.5C13.6667 16 13.8208 16.0375 13.9625 16.1125C14.1042 16.1875 14.225 16.2917 14.325 16.425L18.525 21.925C18.4417 21.9583 18.3542 21.9792 18.2625 21.9875C18.1708 21.9958 18.0833 22 18 22H6Z",
    fill: "#001A52"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTaxReport);
export default __webpack_public_path__ + "static/media/ic_tax_report.1088b5d9e8563706bd9bc85132d138ed.svg";
export { ForwardRef as ReactComponent };